import { render, staticRenderFns } from "./amazonModal.vue?vue&type=template&id=ddb137c4&scoped=true&"
import script from "./amazonModal.vue?vue&type=script&lang=js&"
export * from "./amazonModal.vue?vue&type=script&lang=js&"
import style0 from "./amazonModal.vue?vue&type=style&index=0&id=ddb137c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb137c4",
  null
  
)

export default component.exports